import { render } from "./EventViewUsers.vue?vue&type=template&id=3a195f06&lang=pug"
import script from "./EventViewUsers.vue?vue&type=script&lang=js"
export * from "./EventViewUsers.vue?vue&type=script&lang=js"

import "./EventViewUsers.vue?vue&type=style&index=0&id=3a195f06&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__